// extracted by mini-css-extract-plugin
export default {"main":"Caption_main__asTcT","title":"Caption_title__oDjQH","content":"Caption_content__bdSbk"};